
import React from 'react';
import { Waves, Anchor, LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

export const DashboardHeader = () => {
  const { signOut, user, profile } = useAuth();

  const handleLogout = async () => {
    await signOut();
  };

  const displayName = profile?.full_name || user?.user_metadata?.full_name || user?.email || 'Yacht Broker';
  const initials = profile?.full_name?.charAt(0) || user?.user_metadata?.full_name?.charAt(0) || user?.email?.charAt(0) || 'Y';

  return (
    <header className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white shadow-2xl border-b border-slate-700">
      <div className="container mx-auto px-4 py-4 sm:px-6 sm:py-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center space-x-3 sm:space-x-4">
            <div className="relative">
              <Waves className="h-10 w-10 text-emerald-400 sm:h-12 sm:w-12" />
              <Anchor className="absolute -bottom-1 -right-1 h-5 w-5 text-white sm:h-6 sm:w-6" />
            </div>
            <div>
              <h1 className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-2xl font-bold text-transparent sm:text-3xl">
                Orca AI
              </h1>
              <p className="text-sm font-medium text-slate-300">Yacht Charter Intelligence Dashboard</p>
            </div>
          </div>
          
          <div className="flex items-center justify-between gap-3 sm:justify-end sm:gap-6">
            <div className="min-w-0 text-left sm:text-right">
              <p className="text-sm text-slate-400">Welcome back</p>
              <p className="truncate font-semibold text-slate-100">
                {displayName}
              </p>
            </div>
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 ring-2 ring-emerald-400/30">
              <span className="text-white font-bold text-sm">
                {initials}
              </span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="shrink-0 border-slate-600 bg-slate-800/50 text-slate-100 hover:bg-slate-700 hover:text-white"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
